/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import Page404 from '@downmixit/common/src/components/page404';
import { isValidUUID } from '@downmixit/common/src/helpers/sites';

const Custom404 = () => <Page404 />;

export const getServerSideProps = (async (context: {
    query: any, req: any, res: any, resolvedUrl: any,
  }) => {
  const { resolvedUrl, res } = context;
  const uuid = resolvedUrl?.match(/^\/(.+?)(?:\/|$)/)?.[1] || null;

  // Implement your URL syntax validation logic here
  const isUuidInPath = uuid && isValidUUID(uuid);

  if (isUuidInPath) {
    console.log(`Old create URL requested - redirecting ${resolvedUrl} to /create/${uuid}`);
    // Redirect to the new URL with a 301 status code if the syntax is valid
    res.setHeader('Location', `/create/${uuid}`);
    res.statusCode = 301;
    res.end();
  }

  return { props: {} };
});

export default Custom404;
